import * as React from 'react';

import PropTypes from 'prop-types';

import CloseThreadButton from 'bundles/discussions/components/threadSettings/CloseThreadButton';
import MoveThreadModal from 'bundles/discussions/components/threadSettings/MoveThreadModal';
import PinThreadButton from 'bundles/discussions/components/threadSettings/PinThreadButton';
import Dropdown from 'bundles/phoenix/components/Dropdown';

import _t from 'i18n!nls/discussions';

import 'css!./__styles__/ThreadSettings';

class ThreadSettings extends React.Component {
  static propTypes = {
    question: PropTypes.object.isRequired,
    shouldShowMoveThread: PropTypes.bool,
  };

  state = {
    showMoveThreadModal: false,
  };

  openMoveThreadModal = () => {
    this.setState({
      showMoveThreadModal: true,
    });
  };

  closeMoveThreadModal = () => {
    this.setState({
      showMoveThreadModal: false,
    });
  };

  renderMoveThreadModal() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'question' does not exist on type 'Readon... Remove this comment to see the full error message
    return <MoveThreadModal handleClose={this.closeMoveThreadModal} question={this.props.question} />;
  }

  renderNonItemEntries() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'shouldShowMoveThread' does not exist on ... Remove this comment to see the full error message
    if (this.props.shouldShowMoveThread) {
      return (
        <button className="nostyle" onClick={this.openMoveThreadModal}>
          {_t('Move Thread')}
        </button>
      );
    }

    return null;
  }

  render() {
    const listItems = [<CloseThreadButton />, <PinThreadButton />, this.renderNonItemEntries()];

    return (
      <div className="rc-ThreadSettings">
        <Dropdown
          dropdownId="test"
          listItems={listItems}
          iconName="settings"
          iconClassName="color-secondary-text"
          label={_t('View dropdown options')}
        />
        {this.state.showMoveThreadModal && this.renderMoveThreadModal()}
      </div>
    );
  }
}

export default ThreadSettings;
